import { HTTP_TOKEN } from "./http";

export const getAdditionalvalue = params => {
  return HTTP_TOKEN.get("additionalvalue", { params }).then(result => {
    return result.data;
  });
};

export const createAdditionalvalue = data => {
  return HTTP_TOKEN.post("additionalvalue", data).then(result => {
    return result.data;
  });
};

export const updateAdditionalValue = (additionalvalueId, params) => {
  return HTTP_TOKEN.put(`additionalvalue/${additionalvalueId}`, params).then(result => {
    return result.data;
  });
};

export const deleteAdditionalvalue = (additionalvalueId) => {
  return HTTP_TOKEN.delete(`additionalvalue/${additionalvalueId}`).then(result => {
    return result.data;
  });
};

